interface Props {
  items: string[];
}

export function LimitedBadges({ items }: Props) {
  const visible = items.slice(0, 2);
  const hidden = items.length - 2;

  return (
    <div className="flex gap-1.5 whitespace-nowrap">
      {visible.map((item) => (
        <span
          key={item}
          className="px-2.5 py-1 text-xs rounded-full bg-gray-300/30"
        >
          {item}
        </span>
      ))}

      {hidden > 0 && (
        <span
          title={items.join(", ")}
          className="px-2.5 py-1 text-xs rounded-full bg-gray-200 cursor-pointer"
        >
          +{hidden} more
        </span>
      )}
    </div>
  );
}
